export abstract class StorageServiceAbstract {
  abstract setItem(property: string, value: any): void;
  abstract getItem(property: string): void;
  abstract removeItem(property: string): void;
  abstract getAllItems(): void;
}
